import api from '../../../config/axios'

export const AcceptanceCriteriaService = {
  updateAcceptanceCriteria: (id: string, criteria: Record<string, number>) =>
    api.put<{
      message: string;
      sensor_type_id: string;
      acceptance_criteria: Record<string, number>;
    }>(`/sensor-types/${id}/acceptance-criteria`, criteria).then(res => res.data),
}
